// extracted by mini-css-extract-plugin
export var brand = "_1l-8";
export var compact = "_1l-5";
export var extraSmall = "_1l-6";
export var icon = "_1l-0";
export var large = "_1l-3";
export var light = "_1l-1";
export var medium = "_1l-4";
export var outline = "_1l-a";
export var primaryDark = "_1l-9";
export var primaryLight = "_1l-7";
export var primaryModern = "_1l-b";
export var success = "_1l-2";